import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Profile = () => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [userMetadata, setUserMetadata] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [error, setError] = useState(null);

  //const accessToken = useAccessToken(`https://hem.fomalhaut.se/repo-list-server-context-root/repo-list-server-application-path/rest/v1/`);

  // useEffect(() => {
  //   const getUserMetadata = async () => {
  //     const domain = "dev-6rt7-h43.eu.auth0.com";
  
  //     try {
  //       const accessToken = await getAccessTokenSilently({
  //         audience: `https://${domain}/api/v2/`,
  //         scope: "read:current_user",
  //       });
  
  //       const userDetailsByIdUrl = `https://${domain}/api/v2/users/${user.sub}`;
  
  //       const metadataResponse = await fetch(userDetailsByIdUrl, {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       });
  
  //       const { user_metadata } = await metadataResponse.json();
  
  //       setUserMetadata(user_metadata);
  //     } catch (e) {
  //       console.log(e.message);
  //     }
  //   };
  
  //   getUserMetadata();
  // }, [getAccessTokenSilently, user?.sub]);

  const getAccessToken = useCallback(async () => {
    if(accessToken) {
      return accessToken;
    }

    const myAT = await getAccessTokenSilently({
      audience: `https://hem.fomalhaut.se/repo-list-server-context-root/repo-list-server-application-path/rest/v1/`,
    });

    setAccessToken(myAT);
    return myAT;
  }, [accessToken, getAccessTokenSilently]);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BACK_END_HOST_URL;
  
    console.log("Fetching token silently");
    getAccessToken().then((accessToken) => {

      console.log("Fetched access token: " + accessToken);
      
      console.log("Fetching root repos");
      const rootReposUrl = `${baseUrl}/repo-list-server-context-root/repo-list-server-application-path/rest/v1/repos`;

      axios.get(rootReposUrl, {
        headers: {
          'X-JWT-Assertion': `${accessToken}`,
        },
      }).then((rootReposResponse) => {
          console.log("Successfully called: " + rootReposResponse.data);
          const {repos, path} = rootReposResponse.data;
          repos.forEach((x) => {
            const { displayName, cloneCmd } = x;
            console.log("Repo: " + displayName + ", clone: " + cloneCmd);
          });

          setUserMetadata(repos);
        }).catch(error => {
          setError(error);
        });
    });
  }, [getAccessToken, user?.sub]);

  if(error) return(
    <div>
      <p>An error occured while fetching repos: "{error.message}"</p>
    </div>
  )

  return (
    isAuthenticated && (
      <div>
        <img src={user.picture} alt={user.name} />
        <h2>{user.name}</h2>
        <p>{user.email}</p>
        <p>Back end URL: {process.env.REACT_APP_BACK_END_HOST_URL}</p>
        <h3>User Metadata</h3>
        {userMetadata ? (
          <pre>{JSON.stringify(userMetadata, null, 2)}</pre>
        ) : (
          "No user metadata defined"
        )}
      </div>
    )
  );
};

export default Profile;